import { ParticipantFormFields } from "@shared";

import { FormDialog } from "@/common/components/form-dialog/FormDialog";
import { useTranslation } from "@/translations";

import { useParticipantCreation } from "./hooks/useParticipantCreation";

interface Props {
  onClose: () => void;
}

export function ParticipantCreationDialog({ onClose }: Props) {
  const { t } = useTranslation();
  const { formik } = useParticipantCreation(onClose);

  return (
    <FormDialog
      title={t("proceedingParticipants.create.dialogTitle")}
      onClose={onClose}
      formik={formik}
      submitLabel={t("common.save")}
      paperSx={{ width: 960 }}
    >
      <ParticipantFormFields formik={formik} />
    </FormDialog>
  );
}
